module.exports = __webpack_public_path__ + "img/loading.dafa4436.gif";